export default (value: number, nearestThousand: boolean = false) => {
  if (value >= 1000000) {
    return `£${Number((value / 1000000).toFixed(2)).toLocaleString().replace('.00', '')}m`;
  }

  if (value >= 1000 && nearestThousand) {
    return `£${Math.round(value / 1000)}k`;
  }

  return `£${Math.round(value).toLocaleString()}`;
};
